import styled from 'styled-components'
import { themeStyles, themeMedia } from '../../../styles/theme'

const mobileSlideWidth = '10em'
const gap = '0.75em'

export const StyledOuterMobileWrapper = styled.div`
  overflow-x: auto;
  padding-bottom: 0.5em;
`

export const StyledInnerMobileWrapper = styled.div`
  display: flex;

  width: calc(
    calc(min(${mobileSlideWidth}, 35vw) + ${gap}) * ${(props) => props.length}
  );
  gap: ${gap};

  > * {
    border-radius: 8px;
    overflow: hidden;
    position: relative;
    border: 2px solid transparent;
    transition: 0.2s border;

    &:hover {
      border: 2px solid ${themeStyles.colors.white.main}4D;
    }
  }
`

export const StyledInnerMobileWrapperFallback = styled.div`
  display: flex;

  width: calc(
    calc(min(${mobileSlideWidth}, 35vw) + ${gap}) * ${(props) => props.length}
  );
  gap: ${gap};

  ${themeMedia.desktop`
    width: 100%;
  `}

  > div {
    position: relative;
    width: 100%;
    overflow: hidden;
    border-radius: 8px;

    > div {
      padding-top: 58%; // Same number as logoLink/styles.js padding-top
    }
  }
`
